import { IMaskInput } from 'react-imask';

interface MaskedInputProps {
  mask: string;
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  className?: string;
  autoComplete?: string;
  name?: string;
  id?: string;
}

export function MaskedInput({
  mask,
  value,
  onChange,
  placeholder,
  disabled,
  style,
  className,
  autoComplete = 'on',
  name,
  id,
}: MaskedInputProps) {
  return (
    <IMaskInput
      mask={mask}
      value={value || ''}
      unmask={false}
      onAccept={(maskedValue: string) => {
        onChange?.(maskedValue);
      }}
      placeholder={placeholder}
      disabled={disabled}
      className={className}
      autoComplete={autoComplete}
      name={name}
      id={id}
      style={{
        width: '100%',
        padding: '4px 11px',
        borderRadius: '8px',
        border: '1px solid #d6dbe7',
        fontSize: '14px',
        lineHeight: '1.5714285714285714',
        ...style,
      }}
    />
  );
}

export default MaskedInput;
